module.exports = __webpack_public_path__ + "static/media/98.b9b58f55.png";